var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.667C8.634 2.667 2.666 8.634 2.666 16c0 7.366 5.968 13.333 13.334 13.333 7.365 0 13.333-5.967 13.333-13.333 0-7.366-5.968-13.333-13.333-13.333Zm6.548 9.134L20.36 22.113c-.161.731-.597.909-1.204.564l-3.334-2.456-1.607 1.548c-.178.177-.328.328-.672.328l.236-3.393 6.178-5.58c.269-.237-.06-.371-.414-.135l-7.635 4.807-3.29-1.027c-.715-.226-.731-.715.15-1.06l12.855-4.956c.597-.215 1.119.145.925 1.048Z",
    fill: "#6C727E"
  })));
};
export default SvgTelegram;